import * as yup from 'yup'
import { IInsurancePolicyFormValues } from 'features/Vehicles/types'
import { IntlShape, defineMessages } from 'react-intl'

const expirationDateMessages = defineMessages({
  required: {
    id: 'vehicles.form.insurancePolicy.expirationDate.required',
    defaultMessage: 'Expiration date is required'
  }
})

const documentMessages = defineMessages({
  required: {
    id: 'vehicles.form.insurancePolicy.document.required',
    defaultMessage: 'Document is required'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<IInsurancePolicyFormValues> => {
  const validations = {
    insurancePolicy: yup.object().shape({
      expirationDate: yup.mixed().required(intl.formatMessage(expirationDateMessages.required)),
      document: yup
        .object()
        .shape({
          id: yup.string(),
          name: yup.string(),
          path: yup.string(),
          file: yup.mixed()
        })
        .test('fileRequired', intl.formatMessage(documentMessages.required), function (value) {
          return !!value.file || !!value.path
        })
    })
  }

  return yup.object().shape(validations)
}
